import { isPlatformBrowser } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { WordTemplatesService } from 'src/app/services/word-templates/word-templates.service';
import { WordTemplatePreviewComponent } from './word-template-preview/word-template-preview.component';
import { WordTemplate } from 'src/app/services/word-templates/word-template.model';
import { DialogUploadFileComponent } from './dialog-upload-file/dialog-upload-file.component';

@Component({
    selector: 'app-word-template',
    templateUrl: './word-template.component.html',
    styleUrl: './word-template.component.scss',
    standalone: false,
})
export class WordTemplateComponent implements OnInit {
    @Input() wordTemplate?: WordTemplate;

    @Output() wordTemplateChange = new EventEmitter<WordTemplate>();

    height = 0;
    width = 0;

    constructor(
        private readonly dialog: MatDialog,
        @Inject(PLATFORM_ID) private readonly platformId: Object,
        private readonly wordTemplatesService: WordTemplatesService,
    ) {}

    ngOnInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            this.height = document.body.getBoundingClientRect().height - 400;
            this.width = document.body.getBoundingClientRect().width - 600;
        }
    }

    uploadFile(): void {
        const dialog = this.dialog.open(DialogUploadFileComponent, {
            data: {
                accept: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                id: this.wordTemplate?._id,
            },
            width: '400px',
            maxWidth: '90vw',
        });

        dialog.afterClosed().subscribe((template: WordTemplate | null) => {
            if (template) {
                this.wordTemplate = template;
                this.wordTemplateChange.emit(template);
            }
        });
    }

    downloadFile(): void {
        if (this.wordTemplate && isPlatformBrowser(this.platformId)) {
            this.wordTemplatesService.download({ id: this.wordTemplate._id, target: 'file.docx' }).subscribe((res) => {
                const downloadLink = document.createElement('a');
                downloadLink.href = window.URL.createObjectURL(res.body);
                downloadLink.id = 'word-template-' + this.wordTemplate!._id;
                downloadLink.setAttribute('download', this.wordTemplate!.name);
                document.body.appendChild(downloadLink);
                downloadLink.click();

                document.getElementById('word-template-' + this.wordTemplate!._id)?.remove();
            });
        }
    }

    previewFile(): void {
        if (this.wordTemplate) {
            this.wordTemplatesService
                .download({
                    id: this.wordTemplate._id,
                    target: 'preview-file.pdf',
                })
                .subscribe((res) => {
                    this.dialog.open(WordTemplatePreviewComponent, {
                        data: {
                            url: res.url,
                            height: this.height,
                        },
                        panelClass: 'dialog-pdf-viewer',
                        width: '1000px',
                        maxWidth: '90vw',
                    });
                });
        }
    }
}
